import { useLanguageNamespaceLoader, useLocale } from '@gov-nx/core/service';
import type { BreadcrumbOption } from '@gov-nx/ui/web';
import { PageCode } from '../definitions/codes';

export const useProfileRezaBreadcrumbs = (): {
	options: BreadcrumbOption[];
	isLoading: boolean;
} => {
	const code = PageCode['profil-reza'];
	const { t } = useLocale(code);
	const translations = useLanguageNamespaceLoader(code);

	return {
		isLoading: translations.isLoading,
		options: [
			{ label: t('domu'), toPage: 'dashboard' },
			{ label: t('profil-reza.drobeckova-navigace.profil') },
		],
	};
};
